import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudForm from "../../components/dashboard/form/CrudForm";
import productService from "../../services/productService";
import Swal from "sweetalert2";

export default function HomeSectionCreate() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await productService.getAllProducts();
      const productsArray = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];
      setProducts(productsArray);
    } catch (err) {
      console.error(err);
    }
  };

 const handleSubmit = async (formData) => {
  try {
    const productIds = (formData.products || [])
      .map((product) =>
        typeof product === "object" ? product.id : product
      )
      .filter((id) => id !== undefined && id !== null);

    const payload = {
      name: formData.name,
      status: Boolean(Number(formData.status)),
      product_ids: productIds,
    };

    console.log("Home section payload:", payload);

    const response = await productService.createHomeSection(payload);

    console.log("Home section created:", response.data);

    await Swal.fire({
      title: "Success!",
      text: "Home section created successfully!",
      icon: "success",
      confirmButtonText: "OK",
      confirmButtonColor: "#3b82f6",
    });

    navigate("/admin/home-section-products");
  } catch (err) {
    console.error(
      "Create home section error:",
      err.response?.data || err
    );

    Swal.fire(
      "Error!",
      err.response?.data?.message ||
        err.message ||
        "Something went wrong",
      "error"
    );
  }
};

 return (
  <DashboardWrapper>
    <div className="container mt-4">
      <button
        className="btn btn-secondary mb-3"
        onClick={() => navigate(-1)}
      >
        Back
      </button>

      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="card-title mb-4"         
  >Create Home Section</h4>

          <CrudForm
            initialData={{
              name: "",
              status: 1,
              products: [],
            }}
            onSubmit={handleSubmit}
            allowedFields={["name", "status", "products"]}
            customFields={{ products: { type: "multi-select" } }}
            products={products}
          />
        </div>
      </div>
    </div>
  </DashboardWrapper>
);
}